import { Directive, ElementRef, Renderer2, OnInit, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appStatusinfo]'
})
export class StatusinfoDirective implements OnInit {
  private icon;
  private text;

  constructor(private el: ElementRef, private renderer: Renderer2 ) {


  }

  @Input()
  public status = '';


  @HostListener('mouseenter')
  mouseenter() {
    try {
    this.renderer.removeChild(this.el.nativeElement, this.icon);
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.text);
    } catch (e) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.text);
    }
  }

  @HostListener('mouseleave')
  mouseleave() {
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', '');
    this.renderer.appendChild(this.el.nativeElement, this.icon);
  }



  ngOnInit(): void {

    this.icon = this.renderer.createElement('img');
    this.renderer.appendChild(this.el.nativeElement, this.icon);
    switch (this.status) {
      case 'cancel':
        this.icon.src = '/assets/statuscan.png';
        this.text = 'Anulowano';
        break;

      case 'inprogress':
        this.icon.src = '/assets/statusinp.png';
        this.text = 'Oczekuje';
        break;

      case 'finished':
        this.icon.src = '/assets/statusok.png';
        this.text = 'Ok';
        break;

      default:
        this.icon.src = '/assets/statusukn.png';
        this.text = 'Nieznany';
        break;

    }
  }


}
